import { NgModule } from '@angular/core';
import { environment } from '@env/environment';
import { AuthModule, LogLevel } from 'angular-auth-oidc-client';

@NgModule({
  imports: [
    AuthModule.forRoot({
      config: {
        autoUserInfo: false,
        authority: environment.auth.issuer,
        redirectUrl: `${window.location.origin}/callback`,
        postLoginRoute: 'login',
        clientId: 'viatracks.spa',
        scope: 'openid profile viatracks:api offline_access email',
        responseType: 'code',
        silentRenew: true,
        silentRenewUrl: window.location.origin + '/silent-renew.html',
        useRefreshToken: true,
        logLevel: LogLevel.Error,
        postLogoutRedirectUri: window.location.origin,
      },
    }),
  ],
  exports: [AuthModule],
})
export class AuthConfigModule {}
